import { Navigate, Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import NotFound from "../components/NotFound";
import TermsOfUse from "../pages/TermsOfUse";
import RefundPolicy from "../pages/RefundPolicy";
import CompatibilityPolicy from "../pages/CompatibilityPolicy";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import { ScrollToTopPage } from "../utils/scrollToElement";

const RootRouter = () => {
  return (
    <>
      <ScrollToTopPage />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route>
          <Route path="404" element={<NotFound />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Route>
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/compatibility" element={<CompatibilityPolicy />} />
      </Routes>
    </>
  );
};

export default RootRouter;
